import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import {
  Box,
  TextField,
  Button,
  Typography,
  CircularProgress,
} from "@mui/material";
import api from "./api/api";
import { ENDPOINTS } from "./api/endpoints";
import Navigation from "./RootNavigation";
import Footer from "./Footer";

const ForgotPassword = () => {
  const [email, setEmail] = useState("");
  const [captchaQuestion, setCaptchaQuestion] = useState("");
  const [captchaAnswer, setCaptchaAnswer] = useState("");
  const [captchaUserInput, setCaptchaUserInput] = useState("");
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState("");
  const [error, setError] = useState("");
  const navigate = useNavigate();

  useEffect(() => {
    generateCaptcha();
  }, []);

  const generateCaptcha = () => {
    const num1 = Math.floor(Math.random() * 10);
    const num2 = Math.floor(Math.random() * 10);
    setCaptchaQuestion(`${num1} + ${num2} = ?`);
    setCaptchaAnswer((num1 + num2).toString());
    setCaptchaUserInput("");
  };

  const isValidEmail = (email) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setMessage("");

    if (!email.trim() || !isValidEmail(email)) {
      setError("Please enter a valid email address.");
      return;
    }

    if (captchaUserInput.trim() !== captchaAnswer) {
      setError("Incorrect CAPTCHA answer. Please try again.");
      generateCaptcha();
      return;
    }

    setLoading(true);
    try {
      const { data } = await api.post(ENDPOINTS.forgotPassword(), { email });
      if (data?.httpStatusCode === 200) {
        setMessage("Password reset link sent to your email.");
      } else {
        setError(data.message || "Failed to send password reset link.");
      }
    } catch {
      setError("Unable to connect. Please try again later.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
          <Navigation />
    <Box
      sx={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        minHeight: "100vh",
        backgroundColor: "#eee",
        fontFamily: "Source Sans 3, sans-serif",
      }}
    >
      <Box
        sx={{
          p: 5,
          width: "100%",
          maxWidth: 420,
          backgroundColor: "#fff",
          borderRadius: 3,
          boxShadow: 3,
          textAlign: "center",
        }}
      >
        <Typography
          variant="h4"
          sx={{ fontWeight: 600, mb: 3, color: "#333" }}
        >
          Forgot Password
        </Typography>

        <form onSubmit={handleSubmit}>
          <TextField
            fullWidth
            label="Email ID"
            variant="outlined"
            margin="normal"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
            InputProps={{ sx: { fontSize: "1rem" } }}
          />

          <TextField
            fullWidth
            label={`CAPTCHA: ${captchaQuestion}`}
            variant="outlined"
            margin="normal"
            value={captchaUserInput}
            onChange={(e) => setCaptchaUserInput(e.target.value)}
            required
            InputProps={{ sx: { fontSize: "1rem" } }}
          />

          {error && (
            <Typography color="error" variant="body2" sx={{ mt: 1 }}>
              {error}
            </Typography>
          )}
          {message && (
            <Typography color="primary" variant="body2" sx={{ mt: 1 }}>
              {message}
            </Typography>
          )}

          <Button
            type="submit"
            fullWidth
            variant="contained"
            disabled={loading}
            sx={{
              mt: 3,
              py: 1.2,
              fontSize: "1.1rem",
              textTransform: "none",
              fontWeight: 600,
              backgroundColor: "#90b5fe",
              "&:hover": { backgroundColor: "#90b5fe" },
            }}
          >
            {loading ? <CircularProgress size={24} color="inherit" /> : "Send Reset Link"}
          </Button>

          <Button
            variant="text"
            fullWidth
            sx={{
              mt: 2,
              fontSize: "1rem",
              color: "#333",
              textTransform: "none",
            }}
            onClick={() => navigate("/login")}
          >
            Back to Login
          </Button>
        </form>
      </Box>
    </Box>
      <Footer />
      </>
  );
};

export default ForgotPassword;
